<template>
    <div>
        <v-snackbar v-if="currentSnackbar" :value="true" timeout="-1">
            {{ currentSnackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn text @click="close" v-bind="attrs">
                    <template v-if="hasMoreSnackbars">
                        {{ labelNext }}
                    </template>
                    <template v-else>
                        {{ labelClose }}
                    </template>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'v-snackbars',
    components: {},
    props: {
        snackbars: Array,
        labelClose: String,
        labelNext: String,
    },
    data: () => ({}),
    computed: {
        hasSnackbars() {
            return this.snackbars.length > 0;
        },
        currentSnackbar() {
            let currentSnackbar = false;
            if (this.hasSnackbars) {
                currentSnackbar = this.snackbars[0];
            }
            return currentSnackbar;
        },
        hasMoreSnackbars() {
            return this.snackbars.length > 1;
        },
    },
    methods: {
        close() {
            this.$emit('close', this);
        },
    },
};
</script>
